var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { ref: "footerContacts", staticClass: "footer-contacts" },
    [
      _c("wrapper", [
        _c("div", { staticClass: "big-title" }, [_vm._v("Обратная связь")]),
        !_vm.requestResult
          ? _c(
              "form",
              {
                staticClass: "contacts-form",
                class: { loading: _vm.loading },
                attrs: { action: "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.handleSubmit($event)
                  }
                }
              },
              [
                _c("div", { attrs: { id: "captcha-container" } }),
                _c("div", { staticClass: "form__inputs" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-container",
                      class: { "border-error": _vm.nameError }
                    },
                    [
                      _c("input-text", {
                        attrs: {
                          label:
                            "Напишите здесь Ваш вопрос и укажите Вашу контактную информацию для обратной связи",
                          light: true
                        },
                        on: {
                          valid: function($event) {
                            _vm.nameValid = true
                          },
                          invalid: function($event) {
                            _vm.nameValid = false
                          }
                        },
                        model: {
                          value: _vm.name,
                          callback: function($$v) {
                            _vm.name = $$v
                          },
                          expression: "name"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("button", { staticClass: "btn large solid--green" }, [
                  _c("span", [_vm._v("Связаться со мной")])
                ]),
                _c(
                  "div",
                  {
                    class: {
                      "border-error": !_vm.agree,
                      "input-container": true,
                      "contacts-form__check": true
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.agree,
                          expression: "agree"
                        }
                      ],
                      staticClass: "contacts-form__checkbox",
                      attrs: {
                        type: "checkbox",
                        name: "agree",
                        id: "contacts-form__agree",
                        required: "",
                        checked: ""
                      },
                      domProps: {
                        checked: Array.isArray(_vm.agree)
                          ? _vm._i(_vm.agree, null) > -1
                          : _vm.agree
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.agree,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.agree = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.agree = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.agree = $$c
                            }
                          },
                          function($event) {
                            _vm.onAgree()
                          }
                        ]
                      }
                    }),
                    _c("label", { attrs: { for: "contacts-form__agree" } }, [
                      _vm._v(
                        "Согласен на обработку своих персональных данных – в соответствии"
                      ),
                      _c("br"),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "/upload/docs/pdf/privacy_policy_www.pdf",
                            target: "_blank"
                          }
                        },
                        [_vm._v("с политикой конфиденциальности")]
                      ),
                      _vm._v(" компании Russ Outdoor")
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "request-result",
            class: { show: _vm.requestResult !== null }
          },
          [
            _vm.requestResult === "success"
              ? _c("h3", [_vm._v("Спасибо! Мы скоро свяжемся с вами.")])
              : _vm._e(),
            _vm.requestResult === "fail"
              ? _c("div", {}, [
                  _c("h3", [_vm._v(_vm._s(_vm.requestErrorText))]),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "btn  large outline--blue link",
                        on: { click: _vm.reset }
                      },
                      [_c("span", [_vm._v("Попробовать ещё раз")])]
                    )
                  ])
                ])
              : _vm._e()
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-640d07ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-640d07ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/footer/FooterContact.vue
// module id = WbyJ
// module chunks = 41